export const successionKeyJobsSelector = state => state.successionKeyJobs;
